import React, { Component } from 'react'
import ReactDOM from 'react-dom/client';
import axios from 'axios';

import './css/bootstrap.min.css';
import './css/main-body.css';
import './css/main-product.css';

import './fonts/ClanProRegular-normal.js';
import './fonts/ClanProMedium-normal.js';

import Product from './components/Product';

export default class App extends Component
{
    constructor (props)
    {
        // Props
        super(props);

        // State
        this.state = {

            // Content

            // Product collection format: [id, displayname_nl, displayname_fr]
            content_product_collections: [],

            // Product type format: [id, displayname_nl, displayname_fr, collection_id, property_dimensions,  property_weightclass__displayname_nl, property_weightclass__displayname_fr, property_application__displayname_nl, property_application__displayname_fr, property_parking, property_wateropening, property_grassopening, property_filling_grass, property_filling_gravel_min, property_filling_gravel_max, property_jointwidth, property_jointdiameter, property_waterpermeability]
            content_product_types: [],
            
            // Translation format: [key, language_nl, language_fr]
            content_translations: [],
            
            content_called: false,
            content_loaded: false,
            
            // Selection
            selection_product_types: [], // Array with boolean per product selected, that matches content_product_types
            
            // Window
            window_height: 0
        }

        // Translation
        this.translation_language_key = 'nl';
        if (window.location.origin === 'https://generateurdetextures.facade.stone-style.ebema.be')
        {
            this.translation_language_key = 'fr';
            document.documentElement.lang = 'fr-BE';
        }
        
        this.translation_nl = {};
        this.translation_fr = {};
        this.translate = this.translate.bind(this);

        // Content
        this.content_product_collections_loaded = false;
        this.content_product_types_loaded = false;
        this.content_translations_loaded = false;

        this.get_content_product_collections = this.content_get_product_collections.bind(this);
        this.get_content_product_types = this.content_get_product_types.bind(this);
        this.get_content_get_translations = this.content_get_translations.bind(this);
        this.content_check_loaded = this.content_check_loaded.bind(this);

        // Selection
        this.get_selection_product_collection = this.get_selection_product_collection.bind(this);
        this.selection_product_collection = this.selection_product_collection.bind(this);
        this.selection_product_type = this.selection_product_type.bind(this);

        // Startup
        this.startup = this.startup.bind(this);

        // Debug
        this.debug = true;

        // IP
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
            this.ip = 'http://127.0.0.1:8001';
        else
            this.ip = window.location.origin;

        if (this.debug === true)
            console.log('IP: '+this.ip);
    }

    // -------------------------------------------------------------------

    // Translate
    translate(key)
    {
        switch (this.translation_language_key)
        {
            case 'nl': return this.translation_nl[key];
            case 'fr': return this.translation_fr[key];
            default: return this.translation_nl[key];
        }
    }

    // -------------------------------------------------------------------

    // Content get product collections
    content_get_product_collections()
    {
        const get_product_collections = async () => {
            try
            {
                const response = await axios.get(this.ip+'/backend/api/get_content_product_collections');
                
                this.setState({
                    content_product_collections: response.data
                }, () => {
                    if (this.debug === true)
                    {
                        console.log('Content product collections');
                        console.log(this.state.content_product_collections);
                    }

                    this.content_product_collections_loaded = true;
                    this.startup();
                });
            }

            catch(error)
            {
                console.log(error);
            }
        }

        get_product_collections();
    }

    // Content get product types
    content_get_product_types()
    {
        // Create the selection_product array according to the 
        const get_product_types = async () => {
            try
            {
                const response = await axios.get(this.ip+'/backend/api/get_content_product_types');
                
                this.setState({
                    content_product_types: response.data,
                    selection_product_types: Array(response.data.length).fill(false)
                }, () => {
                    if (this.debug === true)
                    {
                        console.log('Content product types');
                        console.log(this.state.content_product_types);
                    }

                    this.content_product_types_loaded = true;
                    this.startup();
                });
            }

            catch(error)
            {
                console.log(error);
            }
        }
        
        get_product_types();
    }

    // Content get translations
    content_get_translations()
    {
        const get_translations = async() => {
            try
            {
                const response = await axios.get(this.ip+'/backend/api/get_content_translations');
                
                this.setState({
                    content_translations: response.data
                }, () => {
                    if (this.debug === true)
                    {
                        console.log('Content translations');
                        console.log(this.state.content_translations)
                    }

                    // Build translation dictionary
                    for (let i = 0; i < this.state.content_translations.length; i++)
                    {
                        let key = this.state.content_translations[i]['key'];
                        this.translation_nl[key] = this.state.content_translations[i]['language_nl'];
                        this.translation_fr[key] = this.state.content_translations[i]['language_fr'];
                    }
                    
                    this.content_translations_loaded = true;
                    this.startup();
                });
            }
            
            catch(error)
            {
                console.log(error);
            }
        }

        get_translations();
    }

    // Content check loaded
    content_check_loaded()
    {
        // Normal mode
        if (this.content_product_collections_loaded === true
        && this.content_product_types_loaded === true
        && this.content_translations_loaded === true)
        {
            if (this.debug === true)
                console.log('Content true');
            
            return true;
        }
    }

    // -------------------------------------------------------------------

    // Get selection product collection
    // Returns: total amount of product types in this product collection,
    //          total amount of product types selected in this product collection
    get_selection_product_collection(product_collection_id)
    {
        let total = 0;
        let total_selected = 0;
        for (let i = 0; i < this.state.content_product_types.length; i++)
        {
            if (this.state.content_product_types[i]['collection_id'] === product_collection_id)
            {
                total++;
                
                if (this.state.selection_product_types[i] === true)
                    total_selected++;
            }
        }

        return { total, total_selected };
    }
    
    // Selection product collection
    selection_product_collection(product_collection_id)
    {
        let { total, total_selected } = this.get_selection_product_collection(product_collection_id);

        if (total === total_selected)
        {
            // If all was selected, de-select all

            let selection_product_types = this.state.selection_product_types;
            for (let i = 0; i < this.state.content_product_types.length; i++)
            {
                if (this.state.content_product_types[i]['collection_id'] === product_collection_id)
                {
                    total++;

                    selection_product_types[i] = false;
                }
            }
            
            this.setState({
                selection_product_types: selection_product_types
            })
        }
        else
        {
            // If at least one was not selected, select all

            let selection_product_types = this.state.selection_product_types;
            for (let i = 0; i < this.state.content_product_types.length; i++)
            {
                if (this.state.content_product_types[i]['collection_id'] === product_collection_id)
                {
                    total++;

                    selection_product_types[i] = true;
                }
            }
            
            this.setState({
                selection_product_types: selection_product_types
            })
        }
    }

    // Selection product type
    selection_product_type(product_type_id)
    {
        let selection_product_types = this.state.selection_product_types;
        selection_product_types[product_type_id] = !selection_product_types[product_type_id];

        this.setState({
            selection_product_types: selection_product_types
        })
    }

    // -------------------------------------------------------------------
    
    // Startup
    startup()
    {
        if (this.content_check_loaded() === true)
        {
            if (this.state.content_loaded === false)
            {
                this.setState({
                    content_loaded: true
                }, () => {
                    // Do something
                });
            }
        }
    }

    // -------------------------------------------------------------------

    componentDidMount()
    {
        // Failsafe
        if (this.state.content_called === false)
        {
            this.setState({
                content_called: true
            }, () => {
                if (this.debug === true)
                    console.log('Initiate loading');

                // Normal mode
                this.content_get_product_collections();
                this.content_get_product_types();
                this.content_get_translations();

                //this.message_post_height();
            });
        }

        /*
        window.addEventListener('message', (event) => {
            this.message_incoming(event);
        });

        // Check if parent exists
        if (window.top !== window.self)
        {
            this.message_post_request_window_height();
        }
        else
        {
            // Set the initial window height
            this.setState({
                window_height: window.innerHeight
            });
        }
        */
        
        // Set the initial window height
        this.setState({
            window_height: window.innerHeight
        });
    };

    /*
    componentWillUnmount()
    {
        this.canvas_autosave_reference = null;
    }
    */
    
    // -------------------------------------------------------------------
    
    // Render
    render()
    {
        let debug = '';
        if (this.debug === true)
        {

        }

        // Handle standalone or iframe size
        let body_style;
        if (this.state.window_height !== null)
        {
            body_style = {
                height: this.state.window_height+'px'
            }
        }
        else
        {
            body_style = {
                height: window.innerHeight+'px'
            }
        }

        // Normal mode

        /*
        const debug_selection = [];
        for (let i = 0; i < this.state.selection_product_types.length; i++)
        {
            if (this.state.selection_product_types[i] == true)
            {
                debug_selection.push(
                    <div key={i}>{i} {'>'} true</div>
                );
            }
            else
            {
                debug_selection.push(
                    <div key={i}>{i} {'>'} false</div>
                );
            }
        }
        */

        return (
            <React.Fragment>
                <div className="body-product" style={body_style}>
                    {/*
                    <div>{debug_selection}</div>
                    */}

                    <Product
                        content_product_collections={this.state.content_product_collections}
                        content_product_types={this.state.content_product_types}
                        selection_product_types={this.state.selection_product_types}
                        translation_language_key={this.translation_language_key}
                        function_get_selection_product_collection={this.get_selection_product_collection}
                        function_selection_product_collection={this.selection_product_collection}
                        function_selection_product_type={this.selection_product_type}
                        function_translate={this.translate} />
                </div>
            </React.Fragment>
        );

        // Failsafe
        return (
            <React.Fragment>
            </React.Fragment>
        );
    }
}

const app = ReactDOM.createRoot(document.getElementById('app'));
app.render(
    <App />
);